module.exports = __webpack_public_path__ + "img/email-dark.973b22af.svg";